import React, { useState, useEffect } from "react";
import { Divider } from "@mui/material";
import { Button } from "@mui/material";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import ListItemButton from "@mui/material/ListItemButton";
import axios from "axios";

export default function YourCart() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const url = "https://cloudapp.aaragroups.com/api/cart-list/";

    axios
      .get(
        url,

        {
          headers: { Token: "c0b20629c2a198e2b1104fbd6adb696a35ed689f" },
        }
      )
      .then((res) => setData(res?.data?.data))
      .catch((err) => console.log("err"));
  }, []);
  console.log(data);

  return (
    <>
      <div className=" flex flex-col lg:flex-row justify-center gap-10 py-10 hm1">
        <div
          className=" px-3 lg:w-1/2 h-fit 
        bg-gray-400 rounded-xl bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-40 border border-gray-100"
        >
          <div className="py-2">
            <p
              className="font-bold text-xl text-white px-10 py-5"
              onClick={() => navigate("/")}
            >
              My Cart
            </p>
            <Divider />
            <div className="flex justify-between  px-3 py-5 rounded-lg text-white">
              <p className="text-white">Web Hosting Starter</p>
              <Button variant="outlined" className="!text-white !border-white">
                Changes
              </Button>
            </div>
          </div>
          <div className="flex-col flex gap-10">
            {data?.splice(0, 2).map((item) => {
              return (
                <>
                  <div className="flex border border-white justify-between !text-white gap-5 rounded-lg py-4 px-10">
                    <div className="flex flex-col justify-center  gap-5">
                      <p>{item.title}</p>
                      <img
                        src={item.product_image}
                        alt=""
                        className="h-24 overflow-hidden text-ellipsis truncate"
                      />
                    </div>

                    <p className="text-left text-white font-bold mt-10 overflow-hidden text-ellipsis truncate">
                      {item.description}
                    </p>

                    <div className="flex flex-col justify-end mb-10">
                      <p className="font-bold text-white overflow-hidden text-ellipsis truncate">
                        {item.price}
                      </p>
                      <p className="font-bold text-white line-through overflow-hidden text-ellipsis truncate">
                        {item.cart_total_price}
                      </p>
                      <p className="font-bold text-white overflow-hidden text-ellipsis truncate">
                        {item.cart_total_discount}
                      </p>
                    </div>
                  </div>
                </>
              );
            })}
          </div>

          <div className="py-2  ">
            <div className="flex gap-10 justify-center py-3  rounded-lg">
              <p className="text-white">
                <BeenhereIcon />
                Save for Later
              </p>
              <div className="border-r-2"></div>
              <p className="text-white">
                <DeleteOutlineOutlinedIcon />
                Remove
              </p>
            </div>
          </div>

          <div className="flex py-5 gap-5  rounded-lg px-3">
            <p className="text-white">
              <MonetizationOnOutlinedIcon />
              Plan Purchase ?
            </p>
            <Button
              size="small"
              variant="outlined"
              className="!text-white !border-white"
            >
              Yes
            </Button>
            <Button variant="outlined" className="!text-white !border-white">
              No
            </Button>
          </div>
          <Divider />
          <div className="flex justify-between gap-0 py-2 px-3 rounded-lg ">
            <React.Fragment>
              <ListItemButton onClick={() => setOpen(true)} onClose>
                <Button variant="contained" className="!text-white">
                  Proceed to Payement
                </Button>
              </ListItemButton>
              <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
                <div className="hm h-screen lg:px-5 ">
                  <p className="lg:px-3 py-5 text-center text-white font-bold text-xl pt-20">
                    Enter Your Address Details
                  </p>
                  <div className="lg:px-5 px-3 ">
                    <div
                      className=" bg-gray-400 rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-40 border border-gray-100
                    "
                    >
                      <div className="lg:px-5 px-3 py-10 flex-col flex gap-5  ">
                        <input
                          type="text"
                          placeholder="First Name"
                          className="border border-black p-1 rounded lg:w-80 w-56 lg:ml-0 ml-10"
                        />
                        <input
                          type="text"
                          placeholder="Last Name"
                          className="border border-black p-1 rounded lg:w-80 w-56 lg:ml-0 ml-10"
                        />
                        <input
                          type="text"
                          placeholder="Street Address "
                          className="border border-black p-1 rounded lg:w-80 w-56 lg:ml-0 ml-10"
                        />
                        <select className="border border-black p-1 rounded lg:w-80 w-56 lg:ml-0 ml-10">
                          <option>United state</option>
                        </select>
                        <div className="flex flex-col lg:flex-row gap-5">
                          <input
                            type="text"
                            placeholder="City "
                            className="border border-black p-1 rounded lg:w-24  w-56 lg:ml-0 ml-10"
                          />
                          <select className="border border-black p-1 rounded lg:w-24 w-56 lg:ml-0 ml-10">
                            <option>state</option>
                          </select>
                          <input
                            type="text"
                            placeholder="Zip Code "
                            className="border border-black p-1 rounded  lg:w-24  w-56 lg:ml-0 ml-10"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="px-10 py-5">
                      <Button
                        variant="contained"
                        className="!w-full !rounded !font-bold"
                        onClick={() => navigate("/payment")}
                      >
                        Continue
                      </Button>
                    </div>
                  </div>
                </div>
              </Drawer>
            </React.Fragment>

            <p className="text-xl !text-white">₹ 44,1285 </p>
          </div>
        </div>
        <div className="py-2 shadow-xl h-fit !text-white bg-gray-400 rounded-xl bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-40 border border-gray-100">
          <div className="py-2 px-3 text-left !text-white   rounded-lg">
            Price details
          </div>
          <Divider />
          <div className="flex justify-between gap-28 py-5 px-3  rounded-lg">
            {data?.splice(0, 1).map((item) => {
              return (
                <>
                  <div className="flex-col text-left !text-white">
                    <p>{item.price}</p> <p>{item.discount_percent}</p>
                    <p>Professional Email - Individual - 1 year(s)</p>
                  </div>
                  <div className="flex-col !text-white">
                    <p>{item.cart_total_price}</p>{" "}
                    <p>{item.cart_total_discount}</p> <p>12 month</p>
                  </div>
                </>
              );
            })}
          </div>
          <Divider />

          <div className="flex justify-between py-2  rounded-lg px-3 !text-white">
            <p>Total Customer Price</p> <p>₹ 5,880 .....</p>
          </div>
          <Divider />
          <p className="px-3 py-3 text-green-700!text-white ">
            You will save ₹3,777 on this plan
          </p>
        </div>
      </div>
    </>
  );
}
